import React from 'react';
import './VideoSection.css'; // Add styling for the video section

const VideoSection = () => {
  return (
    <section className="video-section">
      <video className="background-video" autoPlay loop muted>
        <source src="https://cdn.pixabay.com/vimeo/761273478/room-135141.mp4?width=1280&hash=a216e70ded56228eb84a46c9120fb2c8bbb8d487" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div className="content">
      <h1 id="opp">𝗢𝘃𝗲𝗿 𝟭𝟱𝟳,𝟬𝟬𝟬 𝗵𝗼𝘁𝗲𝗹𝘀 𝗮𝗻𝗱 𝗵𝗼𝗺𝗲𝘀 𝗮𝗰𝗿𝗼𝘀𝘀 𝟯𝟱 𝗰𝗼𝘂𝗻𝘁𝗿𝗶𝗲𝘀</h1>

        <p id="oopp">"Discover comfort and luxury at OYO hotels across India now!"</p>
      </div>
    </section>
  );
};

export default VideoSection;
